import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import {
  Input,
  Loader,
} from 'components';
import { useStateVar } from 'helpers/useStateVar';
import { withTransaction } from '@elastic/apm-rum-react';
import { apiCall } from '~/providers';

export function Inspector(): JSX.Element {
  const [state, render, setState] = useStateVar(() => ({
    loading: false,
    htmlContent: URL.createObjectURL(new Blob([''], { type: 'text/html' })),
    servico: 'monitor',
    dia: new Date().toISOString().substring(0, 10),
  }));

  useEffect(() => {
  }, []);

  async function fetchData() {
    try {
      setState({ loading: true });
      const htmlContent = await apiCall('/devtools/inspectorService', { path: `/tela/${state.servico}?dia=${state.dia}`, pars: {} });
      state.htmlContent = URL.createObjectURL(new Blob([htmlContent], { type: 'text/html' }));
    } catch (err) { console.log(err); toast.error('Houve erro'); }
    setState({ loading: false });
  }

  async function onClicaCarregar() {
    await fetchData();
  }

  return (
    <>
      <Helmet>
        <title>Diel Energia - Inspector</title>
      </Helmet>
      {state.loading && <Loader variant="primary" />}
      {(!state.loading) && (
        <>
          <div style={{ display: 'flex' }}>
            <Input
              value={state.servico}
              onChange={(e) => { state.servico = e.target.value; render(); }}
            />
            <Input
              value={state.dia}
              onChange={(e) => { state.dia = e.target.value; render(); }}
            />
            <button type="button" onClick={onClicaCarregar}>Carregar</button>
          </div>
          <iframe title="Inspector" onLoad={(ev) => corrigirAlturaIFrame(ev.target as HTMLIFrameElement)} style={{ width: '100%' }} src={state.htmlContent} />
        </>
      )}
    </>
  );
}

function corrigirAlturaIFrame(frame: HTMLIFrameElement) {
  if (!frame.contentWindow) return;

  // set the height of the iframe as the height of the iframe content
  frame.style.height = `${frame.contentWindow.document.body.scrollHeight}px`;

  // set the width of the iframe as the width of the iframe content
  frame.style.width = `${frame.contentWindow.document.body.scrollWidth}px`;
}

export default withTransaction('Inspector', 'component')(Inspector);
